const prefix = 'drivex/accessUrls';

const LOAD_ACCESS_URL_SUCCESS = `${prefix}/LOAD_ACCESS_URL_SUCCESS`;

export default {
  LOAD_ACCESS_URL_SUCCESS,
};
